var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-content"},[(_vm.iframeUrl)?_c('iframe',{staticStyle:{"height":"calc(100%)"},attrs:{"id":"iframe","src":_vm.iframeUrl,"width":"100%","frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }